import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6baf1be4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "factor-group",
  ref: "groupEl"
}
const _hoisted_2 = { class: "fg-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FactorGroup = _resolveComponent("FactorGroup", true)!
  const _component_FactorItem = _resolveComponent("FactorItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.depth > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fg-title",
          style: _normalizeStyle({ color: _ctx.colors.textMuted })
        }, [
          _createTextVNode(_toDisplayString(_ctx.group.attrName) + " ", 1),
          (_ctx.groupDesc)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "fg-help",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('openDesc', _ctx.group)))
              }, "?"))
            : _createCommentVNode("", true)
        ], 4))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.group.childAttrList, (child) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: child.attrCode
        }, [
          (child.attrType === null || child.attrType === undefined)
            ? (_openBlock(), _createBlock(_component_FactorGroup, {
                key: 0,
                group: child,
                depth: _ctx.depth + 1,
                "selected-codes": _ctx.selectedCodes,
                "selected-map": _ctx.selectedMap,
                "is-light": _ctx.isLight,
                colors: _ctx.colors,
                headers: _ctx.headers,
                "highlight-code": _ctx.highlightCode,
                onToggle: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggle', $event))),
                onOpenDesc: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('openDesc', $event)))
              }, null, 8, ["group", "depth", "selected-codes", "selected-map", "is-light", "colors", "headers", "highlight-code"]))
            : (_openBlock(), _createBlock(_component_FactorItem, {
                key: 1,
                factor: _ctx.selectedMap.get(child.attrCode) || child,
                selected: _ctx.selectedCodes.has(child.attrCode),
                "is-light": _ctx.isLight,
                colors: _ctx.colors,
                headers: _ctx.headers,
                highlight: _ctx.highlightCode === child.attrCode,
                onToggle: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('toggle', $event)))
              }, null, 8, ["factor", "selected", "is-light", "colors", "headers", "highlight"]))
        ], 64))
      }), 128))
    ])
  ], 512))
}